"use client";

import * as ProgressPrimitive from "@radix-ui/react-progress";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { cx } from "./cx";
import styles from "./progress.module.css";

type ProgressSize = "sm" | "md" | "lg";

export const Progress = forwardRef<
  HTMLDivElement,
  ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
    size?: ProgressSize;
    fillColor?: string;
  }
>(({ className, value = 0, size = "sm", fillColor, ...props }, ref) => (
  <ProgressPrimitive.Root
    ref={ref}
    className={cx(styles.track, styles[size], className)}
    {...props}
  >
    <ProgressPrimitive.Indicator
      className={styles.fill}
      style={{
        width: `${value}%`,
        ...(fillColor ? { background: fillColor } : {}),
      }}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = "Progress";
